import { ORDER_STATUS_TABS, type OrderStatusTabId } from './orderFilters'

interface OrderStatusTabsProps {
  activeTab: OrderStatusTabId
  counts: Record<OrderStatusTabId, number | null>
  onChange: (tab: OrderStatusTabId) => void
}

export default function OrderStatusTabs({ activeTab, counts, onChange }: OrderStatusTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Filtrar órdenes por estado"
      className="flex gap-1 overflow-x-auto rounded-xl bg-slate-100 p-1"
    >
      {ORDER_STATUS_TABS.map((tab) => {
        const isActive = tab.id === activeTab
        const count = counts[tab.id]
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(tab.id)}
            className={[
              'inline-flex min-h-[40px] shrink-0 items-center gap-1.5 rounded-lg px-3 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400',
              isActive ? 'bg-white text-slate-900 shadow-sm' : 'text-slate-600 hover:text-slate-900',
            ].join(' ')}
          >
            {tab.label}
            {count != null ? (
              <span
                className={[
                  'rounded-full px-1.5 py-0.5 text-[11px] font-bold tabular-nums',
                  isActive ? 'bg-slate-900 text-white' : 'bg-slate-200 text-slate-600',
                ].join(' ')}
              >
                {count}
              </span>
            ) : null}
          </button>
        )
      })}
    </div>
  )
}
